// ##### Komarov 2025-07-12
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// ##### 23-09-21 Komarov
import { useLocation } from 'react-router-dom';
// import { ValidateQuery } from "./Components/Pages/Helpers/helper";
// ##### 23-05-10 Komarov
import { HelmetProvider } from 'react-helmet-async';
// ##### 25-05-21 Komarov
import Header from './Components/Pages/PageComponents/ResponsiveHeader/Header/Header';
// ##### 25-05-21 Komarov
import HeaderWhiteLabel from './Components/Pages/PageComponents/ResponsiveHeader/HeaderWhiteLabel';
import Footer from './Components/Pages/RoutesAndLinks/Footer';
// ##### 25-01-22 Komarov
import {
  changeLang,
  getLangResponse,
  setCurrentUrl,
  setLanguage,
} from './Redux/actions';
// ##### Komarov 2025-07-24
import RouteSwitcher from './Components/Pages/RoutesAndLinks/RouteSwitcher';
// ##### Komarov 2025-08-26
import { setTimeMark } from './utils/timeUtils';
// ##### 24-07-25 Komarov
// import { setPromoCode } from "./Redux/actions/promocode";

let effectNumber = 0;
const componentName = 'LocalizationWrapper';

// ##### Komarov 2025-07-14
const LocalizationWrapper = props => {
  // ##### 23-09-21 Komarov
  // let path;
  const location = useLocation();

  // ##### 24-07-24 Komarov
  const browserLang = location.pathname.substring(1, 3);
  // ##### Komarov 2025-07-12
  // ##### Komarov 2025-08-27
  const componentDevMode = useSelector(state => state.devMode);
  useEffect(() => {
    dispatch(setLanguage(browserLang));
    componentDevMode && setTimeMark(`l:41 ${componentName} effect ${++effectNumber} end:`, componentDevMode);
  }, [browserLang]);

  // ##### 24-08-01 Komarov
  const browserUrl = `${location.pathname}${location.search}`.substring(3);
  // ##### Komarov 2025-07-12
  useEffect(() => {
    dispatch(setCurrentUrl(browserUrl));
    componentDevMode && setTimeMark(`l:49 ${componentName} effect ${++effectNumber} end:`, componentDevMode);
  }, [browserUrl]);

  // ##### 24-08-05 Komarov
  // const company_id = useSelector(state => state.auth.user.company_id);

  // TODO: Исправить код в соответствии с задачей убрать Промокод из URL
  /* if (location.search) {
    path = ValidateQuery(location);
  } else path = { refpartner: "", default: true }; */

  const dispatch = useDispatch();

  // ##### 23-09-21 Komarov: Если значение промокода есть в URL, на который перешёл пользователь, а значение кода при этом пустое, то устанавливаем промокод в state из URL
  // ##### 24-07-25 Komarov
  // TODO: Происходит смешивание понятий refpartner и promoCode, - нужно что-то с этим сделать
  /* useEffect(() => {
    path.refpartner && dispatch(setPromoCode(path.refpartner));
  }, [dispatch, path.refpartner]); */

  // ##### 23-11-09 Komarov: Прокручиваем окно вверх (на начало) при переходе на любую страницу
  const currentUrl = useSelector(state => state.currentUrl);
  // ##### Komarov 2025-07-12
  useEffect(() => {
    // ##### 23-11-09 Komarov
    // Если пользователь уточняет даты поиска во вторичной форме поиска, или пользователь находится в Галлерее и открывает или закрывает блок с фотографиями, то не прокручиваем страницу наверх
    if (
      // ##### 24-03-21 Komarov
      (typeof currentUrl === 'string' &&
        currentUrl.includes('start') &&
        currentUrl.includes('hotel_details')) ||
      // ##### 24-03-21 Komarov
      typeof currentUrl === 'object'
    )
      return;
    window.scrollTo(0, 0);
  }, [currentUrl]);

  // ##### 24-03-21 Komarov
  // const promoCode = useSelector((state) => state.promocode.promocode);
  // ##### 23-05-10 Komarov
  const helmetContext = {};
  const { locale } = props.match.params;
  // ##### 24-02-28 Komarov
  const isWhiteLabelSet = useSelector(state => state.whitelabel.set);

  // ##### Komarov 2025-07-12
  useEffect(() => {
    dispatch(changeLang(locale));
    componentDevMode && setTimeMark(`l:98 ${componentName} effect ${++effectNumber} end:`, componentDevMode);
    // ##### 23-04-12 Komarov
  }, [locale, dispatch]);

  // ##### Komarov 2025-07-12
  useEffect(() => {
    dispatch(getLangResponse());
    componentDevMode && setTimeMark(`l:105 ${componentName} effect ${++effectNumber} end:`, componentDevMode);
    // ##### 23-04-12 Komarov
  }, [dispatch]);

  localStorage.setItem('currentLanguage', locale);

  // ##### 24-02-28 Komarov
  return (
    <HelmetProvider context={helmetContext}>
      {(isWhiteLabelSet && <HeaderWhiteLabel />) || <Header />}
      { /* ##### Komarov 2025-07-24 */}
      <RouteSwitcher />
      <Footer />
    </HelmetProvider>
  );
};

// ##### 25-05-21 Komarov
export default LocalizationWrapper;
